import React from "react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/data";
import { privacyPolicy } from "../lib/privacy";

export default function Privacy() {
  const { lang } = useLang();
  const data = privacyPolicy[lang];

  return (
    <>
      <PageHero tag={data.updated} title="Privacy Policy" image={IMAGES.interior} />

      <section className="mx-auto max-w-3xl px-5 py-24 lg:px-8 lg:py-28" data-testid="privacy-content">
        <Reveal>
          <p className="font-body text-base leading-relaxed text-white/70">{data.intro}</p>
        </Reveal>
        <div className="mt-12 space-y-12">
          {data.sections.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-heading text-2xl text-white lg:text-3xl">{s.title}</h2>
              <div className="mt-4 space-y-4">
                {s.body.map((p, j) => (
                  <p key={j} className="font-body text-sm leading-relaxed text-white/60">{p}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
